<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre8">
<h2 class="calibre7" id="pgepubid00003">ILLUSTRATIONS</h2>
<table class="calibre9" id="toi" summary="TOI">
<tbody class="calibre10"><tr class="calibre11">
<td class="calibre12"><span class="smcap1">Lafcadio Hearn</span> (photogravure)</td>
<td class="pgnumber"><a class="pcalibre c" href="#/Text/Section0002">Frontispiece</a></td>
</tr>
<tr class="calibre11">
<td class="attribution">From a photograph taken about 1900.</td>
<td class="pgnumber"> </td>
</tr>
<tr class="calibre11">
<td class="calibre12"><span class="smcap1">Lafcadio Hearn</span></td>
<td class="pgnumber"><a class="pcalibre pginternal" href="#/Text/Section0007#i50">50</a></td>
</tr>
<tr class="calibre11">
<td class="attribution">From a photograph taken about 1873.</td>
<td class="pgnumber"> </td>
</tr>
<tr class="calibre11">
<td class="calibre12"><span class="smcap1">Lafcadio Hearn and Mitchell McDonald</span></td>
<td class="pgnumber"><a class="pcalibre pginternal" href="#/Text/Section0008#i110">110</a></td>
</tr>
<tr class="calibre11">
<td class="calibre12"><span class="smcap1">Lafcadio Hearn</span></td>
<td class="pgnumber"><span class="pcalibre pginternal" href="#/Text/Section0010#i198" title="Link target outside of Sample">198</span></td>
</tr>
<tr class="calibre11">
<td class="attribution">From a photograph taken in the ’70’s.</td>
<td class="pgnumber"> </td>
</tr>
<tr class="calibre11">
<td class="calibre12"><span class="smcap1">Facsimile of Mr. Hearn’s Earlier Handwriting</span></td>
<td class="pgnumber"><span class="pcalibre pginternal" href="#/Text/Section0010#i340" title="Link target outside of Sample">340</span></td>
</tr>
<tr class="calibre11">
<td class="calibre12"><span class="smcap1">Saint-Pierre and Mt. Pelée</span></td>
<td class="pgnumber"><span class="pcalibre pginternal" href="#/Text/Section0010#i410" title="Link target outside of Sample">410</span></td>
</tr>
<tr class="calibre11">
<td class="attribution">From a photograph in the possession of Dr. T. A. Jaggar, Jr.</td>
<td class="pgnumber"> </td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?2343c8be